import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import { SelectOption } from "../../../../../types/select";
import axios from "../../../../../utils/axiosInceptor";
import { ServiceRequest } from "./useGetServiceRequests";

export type ServiceDetailRequest = Omit<ServiceRequest, "ticketStatus"> & {
  ticketStatus: SelectOption;
  serviceRequestDetails?: Record<string, unknown>;
};

type UseGetServiceRequestOptions = {
  ticketId?: string;
  isEnabled?: boolean;
};

const getServiceRequest = async (ticketId: string) => {
  const url = `${apiV1Endpoint}/general-services/service-requests/${ticketId}`;
  const response = await axios.get<ApiResponse<ServiceDetailRequest>>(url);
  return response.data.result;
};

export const useGetServiceRequest = (options: UseGetServiceRequestOptions) => {
  const { ticketId, isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["service-requests", ticketId],
    queryFn: () => getServiceRequest(ticketId),
    enabled: Boolean(ticketId) && isEnabled,
  });

  return { serviceRequest: data, isLoadingServiceRequest: isLoading };
};
